import { render } from "./HistoryComponents.vue?vue&type=template&id=7bbad7fc&ts=true"
import script from "./HistoryComponents.vue?vue&type=script&lang=ts"
export * from "./HistoryComponents.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__